import mutations from "./mutations";
import actions from "./actions";

import { IConfigurationResponse } from "@/apps/merchant3/models/IConfigurationResponse";

export default {
  namespaced: true,
  state: {} as unknown as IConfigurationResponse,
  mutations,
  actions,
};
